import {h} from "preact";
import LFeed from "../../../../services/live-feed"

export const Common = ({ event, children }) => {
	const sport = LFeed.menu[event.sport];
	return	<div class="wrapper-v-a-view h-auto" style={{ height: "auto" }}>
		<div class={"game-control " + sport.label}>
			<div class="game-score-info-l-game">
				<ul>
					<li>
						<p class="team-name-live-game">{event.home}</p>
					</li>
					<li class="game-score-column">
						<div class="live-score-view">
							<span class="score-1-view">
								{event.sport == '/sport/10' || event.sport == '/sport/2'
									? event.misc.stats.score.team1_value
									: event.sport == '/sport/7'
									? event.misc.tracker.set_score.split(":")[0]
									: event.misc.info.score1}
							</span>
							<span class="icon-between-score" />
							<span class="score-2-view">
								{event.sport == '/sport/10' || event.sport == '/sport/2'
									? event.misc.stats.score.team2_value
									: event.sport == '/sport/7'
									? event.misc.tracker.set_score.split(":")[1]
									: event.misc.info.score2}
							</span>
						</div>
					</li>
					<li>
						<p class="team-name-live-game">{event.away}</p>
					</li>
				</ul>
			</div>
			<div class="game-animation-container">
				<div class="playing-field-contain">
					<div class="animation-container">
						<div class="field-container">{children}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
}

export const NewCommon = ({ event, children, isMobile }) => {
	const sport = LFeed.menu[event.sport];
	return (
		<div class="wrapper-v-a-view h-auto" style={{ height: "auto" }}>
			<div class={"game-control " + sport.label}>
				<div class="game-score-info-l-game sss">
					<ul>
						<li>
							<p class="team-name-live-game">{event.home}</p>
						</li>
						<li class="game-score-column">
							<div class="live-score-view">
								<span class="score-1-view">{event.misc.info.score1}</span>
								<span class="icon-between-score" />
								<span class="score-2-view">{event.misc.info.score2}</span>
							</div>
							{event.sport != '/sport/2' && <div class="timeMatch">{event.status.timer+"'"}</div>}
						</li>
						<li>
							<p class="team-name-live-game">{event.away}</p>
						</li>
					</ul>
				</div>

				<div class="new-tracker-container">
					<div class="match-field-contain">
						<div class="animation-container">
							<div class="match-field-container">{children}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
